import { z } from "zod";
import { CountryDTOz, type CountryDTO } from "@shared/contracts";
import { get } from "./client";

export async function fetchCountries(signal?: AbortSignal): Promise<CountryDTO[]> {
  return get("/countries/getCountries", (raw) => z.array(CountryDTOz).parse(raw), { signal });
}